function initialState () {
  return {
    groups: [],
    group: {},
    student: {},
    users: {},
    userForms: {},
    taskProgress: 0,
    forms: [],
    tasks: [],
    tickets: [],
    importUsers: []
  }
}
export function SET_USER_FIELDS (state, { uh, field, groupName }) {
  const fndIndex = state.users[groupName].findIndex(user => user.uh === uh)
  if (fndIndex > -1) {
    field.status = field.status[0].value
    // replace old item with updated fields
    state.users[groupName].splice(fndIndex, 1, {
      ...state.users[groupName][fndIndex],
      ...field
    })
  } else {
    // this should not happen
    console.warn('User not found')
  }
}

export function SET_TASK_PROGRESS (state, progress) {
  state.taskProgress = progress
}

export function SET_FETCHING_USERS (state, bool) {
  state.fetchingUsers = bool
}
export function ADD_USERS (state, { groupName, users }) {
  state.users = { ...state.users, [groupName]: users }
}

export function RESET_USERS_FOR_GROUP (state, { groupName }) {
  state.users = { ...state.users, [groupName]: undefined }
}

export function ADD_FORMS_FOR_USER (state, { uid, forms }) {
  state.userForms = { ...state.userForms, [uid]: forms }
}

export function RESET (state) {
  // acquire initial state
  const s = initialState()
  Object.keys(s).forEach(key => {
    state[key] = s[key]
  })
}

export function CLEAN_GROUP (state) {
  state.groups = []
  state.group = {}
  state.student = {}
  state.forms = []
  state.tasks = []
  state.tickets = []
}

export function SET_GROUP (state, group) {
  state.group = group
}

export function SET_TASKS (state, tasks) {
  state.tasks = state.tasks.filter(t => !tasks.some(task => t.tah === task.tah))
  state.tasks = state.tasks.concat(tasks)
}

export function SET_TICKETS (state, tickets) {
  state.tickets = tickets
}

export function ADD_TICKET (state, ticket) {
  state.tickets.push(ticket)
}

export function UPDATE_FORM (state, form) {
  const index = state.forms.findIndex(t => t.fid === form.fid)
  state.forms.splice(index, 1, form)
}

export function UPDATE_TICKET (state, ticket) {
  const existingTicket = state.tickets.find(t => t.tih === ticket.tih)
  const index = state.tickets.indexOf(existingTicket)
  state.tickets.splice(index, 1, ticket)
}

export function DELETE_TICKET (state, tickethash) {
  state.tickets = state.tickets.filter(t => t.tih !== tickethash)
}

export function SET_FORMS (state, forms) {
  state.forms = forms
}

export function ADD_FORM (state, form) {
  if (state.userForms[state.student.uh]) state.userForms[state.student.uh].push(form)
}

export function SET_GROUPS (state, groups) {
  state.groups = groups
}

export function UPDATE_GROUP (state, group) {
  const g = state.groups.find(g => g.name === group.name)
  state.groups.splice(state.groups.indexOf(g), 1, group)
}

export function ADD_STUDENT_TO_GROUP (state, { student, groupName }) {
  state.users[groupName].push(student)
}

export function SET_STUDENT (state, student) {
  state.student = student
}
